<style lang="stylus">
    .ed-fileview.fileview-sharetome
        .fileview-title
            display flex
</style>

<template>
    <div class="ed-fileview fileview-sharetome" @click="clear()" @contextmenu.stop.prevent>
        <div class="fileview-title">
            {{ $t("title") }}
        </div>

        <RightMenu
            v-if="contextmenuBoxShow"
            :style="{ top: top + 'px', left: left + 'px' }"
            :menuList="[{ label: $t('openFile'), ban: fileSelected.length > 1 }]"
            @handleClicks="fileSelected.length == 1 && openFiles(searchValue ? searchList[fileSelected[0]] : filesList[fileSelected[0]])"
        />

        <div class="filter-box">
            <div class="search-box">
                <input
                    autocomplete="off"
                    spellcheck="false"
                    :data-locate="'search-input'"
                    type="text"
                    v-model="searchValue"
                    :placeholder="$t('search')"
                    @keypress="enter($event)"
                />
                <button class="search-icon" :data-locate="'search-btn'" @click="search()">
                    <iconSymbol :name="'fileSearchIcon'" />
                </button>
            </div>
        </div>

        <div v-if="!searchMode && !emptyStatus" class="fileview-list-header fileview-list-header-sharetome">
            <div class="file-name">
                <span>{{ $t("name") }}</span>
            </div>
            <div class="file-time">
                <span>{{ $t("time") }}</span>
            </div>
            <div class="file-creator">
                <span>{{ $t("creator") }}</span>
            </div>
            <div class="file-permission">
                <span>{{ $t("permission") }}</span>
            </div>
        </div>
        <div class="fileview-scroll" @scroll="clear" @click="clearFile" ref="filesScroll">
            <div class="emptyCloud limit-position" v-cloak v-if="emptyStatus">
                <img src="@/home/assets/img/null-icon/default-null.svg" alt="" />
                <span>{{ $t("notTem") }}</span>
            </div>

            <div class="list-cons">
                <div class="files-box-list" ref="filesBoxList">
                    <listFile
                        v-for="(item, index) in searchMode ? searchList : filesList"
                        :key="index"
                        :type="'shareToMe'"
                        :mode="searchMode ? 'search' : 'shareToMe'"
                        :index="index"
                        :file="item"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
    import fileItem from "../fileItem";
    import listFile from "./listFile.vue";
    import RightMenu from "../RightMenu.vue";
    import FileNum from "./parts/fileNum.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            listFile,
            RightMenu,
            FileNum,
        },
    })
    export default class ShareWith extends Mixins(fileItem) {
        filesList = [];
        searchList = [];
        searchValue = "";
        deleteRecordBlock = false;
        // type = "shareToMe";

        get emptyStatus() {
            return this.userInfo && this.filesList && this.filesList.length == 0 && !this.showLoading;
        }
        get searchMode() {
            return this.$store.state.shareToMe.searchMode;
        }
        set searchMode(v) {
            this.$store.commit("setShareToMeStatus", {
                searchMode: v,
            });
        }
        wbHeaderEvent(obj) {
            let instance = this;
            let func = instance && obj.func_name ? instance[obj.func_name] : null;
            func && func(obj.args);
        }
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }

        get showLoading() {
            return this.$store.state.showLoading;
        }
        get top() {
            return this.$store.state.layoutTop;
        }
        set top(v) {
            this.$store.commit("setState", {
                type: "layoutTop",
                data: v,
            });
        }
        get left() {
            return this.$store.state.layoutLeft;
        }
        set left(v) {
            this.$store.commit("setState", {
                type: "layoutLeft",
                data: v,
            });
        }
        get contextmenuBoxShow() {
            return this.$store.state.fileContextShow;
        }

        set contextmenuBoxShow(v) {
            this.$store.commit("setState", {
                type: "fileContextShow",
                data: v,
            });
        }
        get selectFilesIndex() {
            return this.$store.state.selectFilesIndex;
        }
        set selectFilesIndex(v) {
            this.$store.commit("setState", {
                type: "selectFilesIndex",
                data: v,
            });
        }

        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
        }
        clearFile() {
            this.selectFilesIndex = [];
        }

        enter(e) {
            if (e.keyCode == 13) {
                this.search();
            }
        }

        search() {
            if (this.searchValue) {
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();
                this.searchList = this.filesList.filter((item) => {
                    if (item.name.toLowerCase().includes(this.searchValue.toLowerCase())) {
                        let filePath = item.key.match(/[^\/]+\/[^\/]+\/(.+)/) && item.key.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
                        filePath = filePath.split("/");
                        let name = filePath.pop();
                        filePath = filePath.length ? this.$t("personal") + ">" + filePath.join(">") : this.$t("personal");
                        item.filePath = filePath;
                        return true;
                    }
                    return false;
                });
                if (this.searchList.length == 0) {
                    (<any>this).$edMessage.error(this.$t("notFind"));
                }
                this.$store.commit("setState", { data: false, type: "showLoading" });
            } else {
                this.searchMode = false;
            }
        }

        clear() {
            this.contextmenuBoxShow = false;
        }

        getShareToMeList() {
            this.filesList = [];
            this.$store.commit("setState", { data: true, type: "showLoading" });
            let obj = {
                id: this.params.id,
                token: this.params.token,
                offset: 0,
                count: 100,
            };
            this.$edApi
                .getShareOpenList(obj)
                .then((list) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                    let arr = [];
                    for (let i = 0; i < list.length; i++) {
                        let obj = {
                            id: list[i].id,
                            opened_at: list[i].opened_at,
                            creator: list[i].author,
                            uuid: list[i].uuid,
                            key: list[i].obj,
                            domain: list[i].domain,
                            name: "",
                            permission: list[i].option,
                        };
                        if (this.isPrivate) {
                            obj.name = list[i].title;
                        } else {
                            let nameList = obj.key.split("/");
                            let name = nameList[nameList.length - 1];
                            name = name.match(/(.*)\.eddx/) && name.match(/(.*)\.eddx/)[1];
                            obj.name = name;
                        }
                        arr.push(obj);
                    }
                    arr.sort((a, b) => {
                        return new Date(b.opened_at).getTime() - new Date(a.opened_at).getTime();
                    });
                    console.log(arr);
                    this.filesList = arr;
                })
                .catch((err) => {
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
        }

        loadErr(e) {
            let lang = this.lang == "zh" ? "zh" : "en";
            e.target.src = require(`@/home/assets/img/files/default-files-${lang}.svg`);
        }

        contextmenu(e, files, index) {}

        deleteRecord() {
            if (this.deleteRecordBlock) return;
            this.deleteRecordBlock = true;
            let selectArr = [];
            for (let i = 0; i < this.fileSelected.length; i++) {
                selectArr.push(this.filesList[this.fileSelected[i]].id);
            }
            let params = Object.assign({ objId: selectArr }, this.$store.getters.apiParam);
            this.$edApi
                .deleteOpenRecord(params)
                .then((e) => {
                    this.getShareToMeList();
                    this.deleteRecordBlock = false;
                })
                .catch((e) => {
                    this.deleteRecordBlock = false;
                });
        }
        toShare() {
            this.$bus.$emit("changePCShareView", "share");
        }

        receiveMessage(event) {
            if (event.origin !== location.origin) return;
            if (event.data.type && event.data.type == "updateMyfile") {
                // 更新最近浏览文件
                if (event.data.updateRecentFile) {
                    this.getShareToMeList();
                }
            }
        }
        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        setLayout() {
            this.$store.commit("changeLayout");
            this.clearFile();
        }

        mounted() {
            window.addEventListener("message", this.receiveMessage);
            this.$bus.$on("refreshEv", () => {
                this.getShareToMeList();
            });
            (<any>window).$qt && (<any>window).$qt.jsCallWebUIDisplay && (<any>window).$qt.jsCallWebUIDisplay(); // 通知客户端ui渲染完成
        }
        created() {
            this.$store.commit("setState", { data: 22, type: "selectId" });
            this.$bus.$on("refreshShareToMe", () => {
                this.getShareToMeList();
            });
            if (this.userInfo) {
                if (!this.params.islogin) {
                    return;
                }
                this.getShareToMeList();
            } else {
                this.$bus.$on("loginSucc-shareToMe", () => {
                    this.getShareToMeList();
                });
            }
        }
        beforeDestroy() {
            this.selectFilesIndex = [];
            this.contextmenuBoxShow = false;
            this.$bus.$off("refreshShareToMe");
            this.$bus.$off("loginSucc-shareToMe");
            window.removeEventListener("message", this.receiveMessage);
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "分享给我",
    "share": "我的分享",
    "name": "文件名",
    "time": "打开时间",
    "creator": "创建者",
    "permission": "权限",
    "openFile": "打开",
    "search": "搜索文件",
    "return": "返回",
    "notTem": "暂时还没有小伙伴给你分享文件哦~",
    "personal": "个人云",
    "notFind": "没有找到相应文件"
  },
  "en": {
    "title": "Shared with me",
    "share": "Share",
    "name": "File name",
    "time": "Creation time",
    "creator": "Creator",
    "permission": "Authority",
    "openFile": "Open",
    "search": "Search file",
    "return": "Return",
    "notTem": "No files to show",
    "personal": "Personal",
    "notFind": "Not Find"
  },
  "fr": {
    "title": "Partage avec moi",
    "share": "Ma part",
    "name": "Nom du fichier",
    "time": "Temps de creation",
    "creator": "créateur",
    "permission": "Autorité",
    "openFile": "allumer",
    "search": "Rechercher un fichier",
    "return": "retour",
    "notTem": "Não há amigos para compartilhar arquivos com você.",
    "personal": "Cloud personnel",
    "notFind": "Aucun fichier correspondant trouvé"
  },
  "de": {
    "title": "Teile mit mir",
    "share": "Mein Share",
    "name": "Dateiname",
    "time": "Erstellungszeitpunkt",
    "creator": "Schöpfer",
    "permission": "Behörde",
    "openFile": "anschalten",
    "search": "Datei durchsuchen",
    "return": "Rückkehr",
    "notTem": "Es gibt noch keine Freunde, die Dateien mit Ihnen teilen könnten",
    "personal": "Persönlicher Cloud",
    "notFind": "Keine entsprechende Datei gefunden"
  },
  "jp": {
    "title": "私との共有",
    "share": "私の共有",
    "name": "ファイル名",
    "time": "作成時間",
    "creator": "クリエーター",
    "permission": "権限",
    "openFile": "開く",
    "search": "ファイルを検索",
    "return": "戻る",
    "notTem": "友達が共有したファイルはまだありません",
    "personal": "個人クラウド",
    "notFind": "該当するファイルは見つかりませんでした"
  },
  "es": {
    "title": "Compartido conmigo",
    "share": "Compartir",
    "name": "Nombre del archivo",
    "time": "Tiempo de creación",
    "creator": "Creador",
    "permission": "Autoridad",
    "openFile": "encender",
    "search": "Archivo de búsqueda",
    "return": "regreso",
    "notTem": "Todavía no hay amigos para compartir archivos contigo",
    "personal": "Nube Personal",
    "notFind": "No encontrar"
  },
  "pt": {
    "title": "Compartilhe comigo",
    "share": "Partilhar",
    "name": "Nome de arquivos",
    "time": "Tempo de criação",
    "creator": "O Criador",
    "permission": "Autoridade",
    "openFile": "Ligar",
    "search": "Pesquisar arquivo",
    "return": "Retorna",
    "notTem": "Ainda não há amigos para compartilhar arquivos com você",
    "personal": "Pessoal",
    "notFind": "Não Encontrado"
  },
  "it": {
    "title": "Condividi con me",
    "share": "Condividi",
    "name": "nome del file",
    "time": "Tempo di creazione",
    "creator": "Creatore",
    "permission": "Autorità",
    "openFile": "accendere",
    "search": "Cerca file",
    "return": "ritorno",
    "notTem": "Non ci sono ancora amici con cui condividere file con te",
    "personal": "Personali",
    "notFind": "Nessun file corrispondente trovato"
  },
  "tw": {
    "title": "分享給我",
    "share": "我的分享",
    "name": "檔案名",
    "time": "建立時間",
    "creator": "建立者",
    "permission": "權限",
    "openFile": "打開",
    "search": "搜尋檔案",
    "return": "返回",
    "notTem": "暫時還沒有小夥伴給你分享檔案哦~",
    "personal": "個人雲端硬碟",
    "notFind": "沒有找到相應檔案"
  },
  "kr": {
    "title": "공유된 파일",
    "share": "공유",
    "name": "파일 이름",
    "time": "생성 시간",
    "creator": "생성자",
    "permission": "권한",
    "openFile": "열기",
    "search": "파일 찾기",
    "return": "돌아가기",
    "notTem": "아직 공유된 파일이 없습니다~",
    "personal": "개인 클라우드",
    "notFind": "해당 파일을 찾을 수 없습니다"
  },
  "id": {
    "title": "Bagikan dengan saya",
    "share": "Bagikan",
    "name": "Nama file",
    "time": "Waktu pembuatan",
    "creator": "Kreator",
    "permission": "Otoritas",
    "openFile": "Buka",
    "search": "Cari file",
    "return": "Kembali",
    "notTem": "Tidak ada file untuk ditampilkan",
    "personal": "Personal",
    "notFind": "Tidak Menemukan"
  }
}
</i18n>
